import { calculateDaysRemaining } from 'utils/dateUtils';

/**
 * Inclusive whole days left in a plus membership free trial (end-date day counts as a full day).
 *
 * @param {string | null | undefined} trialEndDate
 * @returns {number | null} Days remaining, or null when the date is missing or already past
 */
export function getInclusiveTrialDaysRemaining(trialEndDate) {
    if (!trialEndDate) {
        return null;
    }

    const daysRemaining = (calculateDaysRemaining(trialEndDate) ?? -1) + 1;

    if (daysRemaining < 0) {
        return null;
    }

    return daysRemaining;
}

/**
 * User-facing copy for how many days remain in a plus membership free trial.
 *
 * @param {Object} params
 * @param {string | null | undefined} params.trialEndDate
 * @param {string} params.plusMembershipShortBranding - Short brand label (e.g. "M+")
 * @param {boolean} [params.withExclamation=false] - Append "!" to the "X days left..." variant
 * @returns {string | null}
 */
export function getTrialDaysRemainingCopy({ plusMembershipShortBranding, trialEndDate, withExclamation = false } = {}) {
    const daysRemaining = getInclusiveTrialDaysRemaining(trialEndDate);

    if (daysRemaining === null) {
        return null;
    }

    if (daysRemaining === 0) {
        return `Last day of your ${plusMembershipShortBranding} trial`;
    }

    const dayLabel = daysRemaining === 1 ? '1 day' : `${daysRemaining} days`;
    const suffix = withExclamation ? '!' : '';

    return `${dayLabel} left in your ${plusMembershipShortBranding} trial${suffix}`;
}
